<template>
  <v-container fluid>
    <PageHeaderSlot />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card class="mb-4">
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="studentCanRequestSwitch"
                :fieldValue.sync="formData.switch_active"
                dispatchUpdateOnChange
                :options="enableOptions"
                required
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0" v-if="formData.switch_active === true">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="needAdminConfirm"
                :fieldValue.sync="formData.need_approve"
                dispatchUpdateOnChange
                :options="needOptions"
                required
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="studentCanChooseLesson"
                :fieldValue.sync="formData.switch_limit"
                dispatchUpdateOnChange
                :options="typeOptions"
                required
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="switchDeadline"
                :fieldValue.sync="formData.request_before_value"
                dispatchUpdateOnChange
                required
                isIntegerOnly
                :prefix="$i18n.locale === 'en' ? 'Before' : ''"
                :suffix="$i18n.locale === 'en' ? 'hour(s)' : '小時前'"
                hint="switchDeadlineDes"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div class="d-flex align-center mt-4" v-if="canEdit">
        <FormButton @click="save()" />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'SwitchSetting',
  components: {
    FormInput,
    FormSelect,
  },
  computed: {
    typeOptions() {
      const vm = this
      let options = [{ value: 'all', text: vm.$t('switchChooseLessonTypes.all') }]
      if (!this.disableCourseGrade) {
        options.push({ value: 'grade', text: vm.$t('switchChooseLessonTypes.grade') })
      }
      options.push({ value: 'course', text: vm.$t('switchChooseLessonTypes.course') })
      return options
    },
    canEdit() {
      // [T46] admin account 只可read
      return !this.isAppMode(['T46']) || this.userType !== 'admin'
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    formData: {
      switch_active: false,
      need_approve: true,
      switch_limit: 'all',
      request_before_value: 0,
    },
    disableCourseGrade: false,
    enableOptions: [
      { value: true, text: vm.$t('can') },
      { value: false, text: vm.$t('cannot') },
    ],
    needOptions: [
      { value: true, text: vm.$t('need') },
      { value: false, text: vm.$t('noNeed') },
    ],
  }),
  methods: {
    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        this.disableCourseGrade = this.gfCheckDisabledCourseGrade(data)
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('toggleLoadingPage', false)
      }
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.canEdit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }
      this.$store.dispatch('setLoading', true)
      let payload = {
        switch_active: this.formData.switch_active,
        need_approve: this.formData.need_approve,
        switch_limit: this.formData.switch_limit,
        request_before_value: this.formData.request_before_value ? parseFloat(this.formData.request_before_value) : 0,
        request_before_unit: 'Hours',
      }

      try {
        await this.$Fetcher.UpdateSetting(payload)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: SwitchSetting')
      this.userType = this.gfGetUserType()
      this.getSetting()
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
